<template>
  <div class="yk_report_pupop" v-loading = "loading">
    <div class="yk_report_form" style="position: relative" >
      <div
        v-preventReClick
        style="
          position: absolute;
          right: 30px;
          top: 30px;
          font-size: 30px;
          color: #606266;
          cursor: pointer;
        "
        @click="back"
      >
        <i class="el-icon-circle-close" />
      </div>
      <div class="ykbb">
        <img
          src="@/assets/img/ykbb.png"
          style="height: 25px; margin-bottom: 37px"
        >
        <el-form
          ref="ysbbForm"
          style="margin-left: -40px"
          label-position="right"
          :model="ysbbForm"
          label-width="190px"
          :rules="rules"
        >
          <el-form-item label="运输许可证:" prop="yszBh">
            <div style="position: relative; width: 100%">
              <el-select
                v-model="ysbbForm.yszBh"
                style="width: calc(100% - 80px)"
                placeholder="请选择"
                :disabled="bgdisable || ckdisable"
                @change="hxsxkzchange"
              >
                <el-option label="同市运输" value="同市运输" />
              </el-select>
              <el-input
                v-model="ysbbForm.yszBh"
                style="
                  position: absolute;
                  width: calc(100% - 115px);
                  left: 0;
                  z-index: 10;
                "
                :disabled="bgdisable || ckdisable"
                placeholder="请输入运输证"
                @blur="hyunshuXkz"
              />

              <el-button
                v-preventReClick
                class="xuanze"
                :disabled="bgdisable || ckdisable"
                @click="dialogShow(2)"
              >选择</el-button>
            </div>
            <!-- <el-input :disabled='ckdisable||bgdisable' style="width: calc(100% - 75px)"></el-input>
            <el-button :disabled='ckdisable||bgdisable' type="primary" class="xuanze">选择</el-button> -->
          </el-form-item>
          <el-form-item class="is-required" label="化学品:" prop="hxpMc">
            <el-input
              v-if="ysbbForm.yszBh != '同市运输' || ckdisable || bgdisable"
              v-model="ysbbForm.hxpMc"
              disabled
            />
            <el-cascader
              v-else
              v-model="ysbbForm.hxpMc"
              style="width: 100%"
              :disabled="ysbbForm.yszBh != '同市运输' || ckdisable || bgdisable"
              :options="jilianlb"
              :emit-path="false"
              @change="hhuaxuepinchange"
            />
          </el-form-item>
          <el-form-item class="is-required" label="移出仓库:" prop="ycqCkmc">
            <el-select
              v-model="ysbbForm.ycqCkmc"
              :disabled="ckdisable"
              style="width: 100%"
              placeholder="请选择"
              @change="hycckchange"
            >
              <el-option
                v-for="(item, k) in ykbbycckXlList"
                :key="k"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="移出保管员:">
            <el-input
              v-model="ysbbForm.ycckbgyxm"
              disabled
              placeholder="移出保管员"
            />
          </el-form-item>
          <el-form-item label="移出保管员手机号:">
            <el-input
              v-model="ysbbForm.ycckbgydh"
              disabled
              placeholder="保管员手机号"
            />
          </el-form-item>
          <el-form-item class="is-required" label="移入仓库:" prop="ychCkmc">
            <el-select
              v-model="ysbbForm.ychCkmc"
              :disabled="ckdisable"
              style="width: 100%"
              placeholder="请选择"
              @change="hyrckchange"
            >
              <el-option
                v-for="(item, k) in ykbbyrckXlList"
                :key="k"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="移入保管员:">
            <el-input
              v-model="ysbbForm.yrckbgyxm"
              disabled
              placeholder="移入保管员"
            />
          </el-form-item>
          <el-form-item label="移入保管员手机号:">
            <el-input
              v-model="ysbbForm.yrckbgydh"
              disabled
              placeholder="保管员手机号"
            />
          </el-form-item>

          <el-form-item v-if="!ckdisable" label="移出仓库当前库存数量:">
            <el-input
              v-model="ycckdqkcsl"
              disabled
              style="width: 65%"
              placeholder="请输入"
            />
            <el-input
              v-model="ycckdqkcsl_dw"
              disabled
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
            />
          </el-form-item>
          <el-form-item class="is-required" label="移库数量:" prop="yksl">
            <el-input
              v-model="ysbbForm.yksl"
              :disabled="ckdisable"
              style="width: 65%"
              placeholder="请输入"
            />
            <el-select
              v-model="ysbbForm.ykslDw"
              :disabled="ckdisable"
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
            >
              <el-option
                v-for="(item, index) in ckslList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!--  prop="cydw" -->
          <el-form-item label="承运单位:" prop="cydw">
            <el-input
              v-model="ysbbForm.cydw"
              :disabled="ysbbForm.yszBh != '同市运输' || ckdisable || bgdisable"
              placeholder="请输入承运单位"
            />
          </el-form-item>
          <!-- prop="cydwTyshxydm" -->
          <el-form-item
            label="承运单位统一社会信用代码:"
            label-width="200px"
            prop="cydwTyshxydm"
          >
            <el-input
              v-model="ysbbForm.cydwTyshxydm"
              :disabled="ysbbForm.yszBh != '同市运输' || ckdisable || bgdisable"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="车号/次:" style="position: relative" prop="hc">
            <el-input
              v-model="ysbbForm.hc"
              :disabled="ckdisable || bgdisable"
              placeholder="请输入车号/次"
            />
            <div
              style="
                position: absolute;
                right: 2px;
                top: 0;
                cursor: pointer;
                font-size: 20px;
                color: #5b96ee;
                height: 30;
                width: 40px;
                background: white;
                margin-top: 4px;
                text-align: center;
                line-height: 30px;
              "
              :title="ysbbForm.hc"
            >
              <i class="el-icon-more" />
            </div>
          </el-form-item>
          <el-form-item class="is-required" label="移库日期:" prop="ykrq">
            <el-date-picker
              v-model="ysbbForm.ykrq"
              style="width: 100%"
              :disabled="ckdisable"
              :picker-options="pickerBeginDateBefore"
              type="date"
              placeholder="请选择"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="经办人:" class="is-required" prop="jbr">
            <el-input
              v-if="ckdisable || bgdisable"
              v-model="ysbbForm.jbrxm"
              disabled
            />
            <el-select
              v-else
              v-model="ysbbForm.jbr"
              filterable
              :disabled="ckdisable || bgdisable"
              style="width: 100%"
              placeholder="请选择"
              @change="hjbrChange"
            >
              <el-option
                v-for="item in jingbanrenlist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="登记人:">
            <el-input v-model="djr" disabled placeholder="请输入" />
          </el-form-item>
          <el-form-item
            v-if="childrenType !== '新增' && childrenType != '复制新增'"
            label="登记时间:"
          >
            <el-input
              v-model="ysbbForm.djsj"
              disabled
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item v-else label="登记时间:">
            <el-date-picker
              :value="new Date()"
              type="date"
              style="width: 100%;"
              placeholder="选择日期"
              disabled
              format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="备注" style="width: 100%" prop="bz">
            <el-input
              v-model="ysbbForm.bz"
              :disabled="ckdisable || bgdisable"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item
            v-if="childrenType == '变更'"
            label="变更理由"
            style="width: 100%"
            prop="bgly"
          >
            <el-input v-model="ysbbForm.bgly" placeholder="请输入" />
          </el-form-item>
        </el-form>
        <div
          v-if="
            childrenType == '复制新增' ||
              childrenType == '新增' ||
              childrenType == '编辑'
          "
          class="buttonList"
        >
          <el-button
            v-preventReClick
            type="primary"
            @click="ZSsave"
          >暂时保存</el-button>
          <el-button
            v-preventReClick
            style=""
            type="primary"
            @click="hbaocun"
          >报备</el-button>
        </div>
      </div>
      <!-- 查看 -->
      <div v-if="childrenType == '查看'" class="backButton">
        <el-button
          v-preventReClick
          type="primary"
          @click="hqueding"
        >确定</el-button>
      </div>
      <!-- 变更 -->
      <div v-if="childrenType == '变更'" class="backButton">
        <el-button
          v-preventReClick
          type="primary"
          @click="htjbg"
        >提交变更</el-button>
      </div>
    </div>
    <div
      v-if="curRowObj.bgcs > 0"
      style="
        width: 90%;
        max-width: 1195px;
        background-color: white;
        margin: auto;
      "
    >
      <div style="width: 90%; padding-top: 20px; margin: auto">
        <img src="../../assets/img/bgsp/ckbg.png" alt="" srcset="">
      </div>
      <bgcsOfDetail
        style="
          width: 90%;
          max-width: 1195px;
          background-color: white;
          margin: auto;
          padding-top: 20px;
          padding-bottom: 10px;
        "
        :cur-row-obj="curRowObj"
        :cur-type="curType"
        :bgcs-t-k-name="'disShow'"
        @bacsCkXqShow="bacsCkXqShow"
      />
    </div>
    <!-- 证件弹框 -->
    <el-dialog title="" :visible.sync="dialogVisible" center>
      <div>
        <!-- <div style="margin-bottom: 20px">
          移库运输： <input type="text" value="2" disabled />
        </div> -->
        <el-table
          ref="xsckTable"
          :data="tableData"
          :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
          border
          :show-overflow-tooltip="true"
          style="
            width: 100%;
            border-left: 1px solid #f4f4f4;
            border-right: 1px solid #f4f4f4;
          "
          :header-cell-class-name="cellClass"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" width="55" />
          <el-table-column
            v-for="(item, i) in table2"
            :key="i"
            :show-overflow-tooltip="true"
            align="center"
            :label="item.label"
            :prop="item.key"
          >
            <template slot-scope="scope">
              <span :title="scope.row[item.key]">
                {{ scope.row[item.key] }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager,next,jumper,total,sizes"
        :page-sizes="[10, 20, 30, 40]"
        :total="total"
        :page-size="bgform.size"
        class="el-page"
        @size-change="pagesizeChange"
        @current-change="handleCurrentChange"
      />
      <div slot="footer">
        <el-button
          v-preventReClick
          @click="dialogVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="hquedingTK"
        >确 定</el-button>
      </div>
    </el-dialog>

    <!-- 变更次数详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible"
        :bgcs-t-k-name="bgcsTKName"
        :dgcs-xq-id="dgcsXqId"
        :xq-type="curType"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bgxqCom from '../bgxq/bgxqCom.vue'
import bgcsOfDetail from '../bgxq/bgInDetail.vue'
import {
  APIysbbtableData, // 购买运输证 弹框数据
  APIhqyszXq, // 运输证详情信息
  APIhuaxuepinJL, // 化学品级联
  APIykbbycckXl, // 移出仓库下拉
  APIykbbyrckXl, // 移入仓库下拉
  APIysbbjbrXl, // 经办人下拉
  APIysbbzanshibc, // 暂时保存
  APIykbbxaingqing, // 查看
  APIykbbbgjiaoyan, //  变更 校验
  APIykbbbgtijiao, // 变更提交
  APIykbbhuoqumorenhxp, // 默认化学品
  APIzancunbianji, APIysbbzanshibcTemp, APIzancunbianjiTemp // 暂存 获取详情
} from '@/assets/js/wangshuai.js'
import { userInfofLogin } from '@/assets/js/common.js'
import { lengthValidate } from '@/assets/js/validate.js'
import { gethqdw } from '@/assets/js/ccgl.js'
import { accMul } from '@/utils/number'
import {dealDataGy} from "@/utils/ppp";
export default {
  components: { bgcsOfDetail, bgxqCom },
  props: ['djrqshow', 'ckdisable', 'bgdisable', 'childrenType'],
  data() {
    const sljiaoyan = (rule, value, callback) => {
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!this.bgdisable && !reg.test(value)) {
        callback(new Error('请输入大于或等于0的数量值'))
      }
      if (/^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) == false) {
        callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      if (!this.ysbbForm.ykslDw) {
        return callback(new Error('请选择移库数量单位'))
      }
      if (this.childrenType !== '变更' && this.childrenType !== '查看') {
        if(!this.jysj()){
            callback(new Error('移库数量不得大于移出仓库当前库存数量'))
        }
        // if (this.getCurrentDw() > this.getCountDw()) {
        //   callback(new Error('移库数量不得大于移出仓库当前库存数量'))
        // }
      }
      callback()
    }
    return {
      loading: false,
      dgcsXqId: null,
      dialogFormVisible: false,
      curType: '',
      curRowObj: {}, // 当前行的对象
      bgcsTKName: '移库报备',
      bgwindow: false,

      // hxpmc_cur: "", // 当前的化学品名称
      cur_yrck_id: '', // 当前的移入仓库id
      cur_ycck_id: '', // 当前的移出仓库id
      // 弹框校验
      rules: {
        bz: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 2000)
            },
            trigger: ['blur', 'change']
          }
        ],
        hc: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 2000)
            },
            trigger: ['blur', 'change']
          }
        ],
        yszBh: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, this.ysbbForm.yszBh, callback, 'bt', 30)
            },
            trigger: ['blur', 'change']
          }
        ],
        // 输入框
        // yszBh: [{ required: true, message: "请输入", trigger: "blur" }],
        yksl: [
          { required: true, validator: sljiaoyan, trigger: ['blur','change'] }
        ],
        bgly: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        cydw: [{ required: true, message: '请输入', trigger: 'blur' }],
        cydwTyshxydm: [{ required: true, message: '请输入', trigger: 'blur' }],

        // 下拉框

        ychCkmc: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        hxpMc: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        ycqCkmc: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],

        ykrq: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        jbr: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ]
      },
      jilianlb: [], // 化学品
      checkedTableList: '',
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      ykbbycckXlList: [], // 移出仓库下拉
      ykbbyrckXlList: [], // 移入仓库下拉
      ckslList: [], // 单位下拉
      jingbanrenlist: [], // 经办人下拉
      // 日期限制
      dialogVisible: false,
      // 页面数据
      ysbbForm: {
        id: '',
        yszBh: '',
        hxpBm: '',
        hxpMc: '',
        ycqCkid: '', // 移出仓库id
        ycqCkmc: '',
        ychCkid: '', // 移入仓库id
        ychCkmc: '',
        yksl: '',
        ykslDw: '',
        ykrq: '',
        yszs: '',
        bz: '',
        zt: '',
        jbr: '',
        jbrxm: '',
        yrckbgyId: '',
        yrckbgyxm: '',
        yrckbgydh: '',
        ycckbgyId: '',
        ycckbgyxm: '',
        ycckbgydh: '',
        hc: '',
        cydw: '',
        cydwTyshxydm: ''
      },

      // 移出仓库当前库存数量
      ycckdqkcsl: '',
      ycckdqkcslDwz:'',
      ycckdqkcsl_dw: '',
      // 运输证
      tableData: [],
      table2: [
        {
          key: 'xkzBh',
          label: '许可证编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'ysdwMc',
          label: '运输单位'
        },
        {
          key: 'fhdwMc',
          label: '发货单位'
        },
        {
          key: 'sqsj',
          label: '申请时间'
        }
      ],
      bgform: {
        page: 1,
        size: 10,
        param: {
          yszType: '2'
        }
      },
      total: 0,
      djr: '', // 登记人
      andleSelectionChangeData_obj: {},
      andleSelectionChangeData_id: 0
    }
  },
  beforeDestroy() {
    this.$bus.$off('fatherToChil')
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.on('fatherToChil', this.initCon)
    })
    // 登记人
    userInfofLogin().then((res) => {
      if (res.status == 200) {
        this.djr = res.data.data.name
      }
    })

    // 化学品下拉
    APIhuaxuepinJL().then((res) => {
      this.jilianlb = res.data.data
    })

    if(this.childrenType == '新增'){
      this.getYrckxxr()
      // 获取下拉经办人
      APIysbbjbrXl().then((res) => {
        this.jingbanrenlist = res.data.data
      })
    }
    // // 移入仓库
    // APIykbbyrckXl().then((res) => {
    //   this.ykbbyrckXlList = res.data.data
    // })

    // 获取运输许可证弹框
    this.htableData()
  },
  methods: {
    lengthValidate,
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
    },

    // 校验移出移入仓库id
    yc_yr_ckID_validate() {
      let validate_flag = false
      this.cur_ycck_id = this.ysbbForm.ycqCkid
      this.cur_yrck_id = this.ysbbForm.ychCkid
      if (this.cur_ycck_id == this.cur_yrck_id) {
        this.$message.error('移入仓库与移出仓库一致，请修改!')
        validate_flag = true
      }
      return validate_flag
    },
    jysj(){
      let flag = true
      if (this.ysbbForm.ykslDw < this.ycckdqkcslDwz) {
        if (
          accMul(this.ysbbForm.yksl, (this.ycckdqkcslDwz - this.ysbbForm.ykslDw) * 1000) > this.ycckdqkcsl
        ) {
          flag = false
        }
      } else if (this.ysbbForm.ykslDw > this.ycckdqkcslDwz) {
        if (
          accMul(this.ysbbForm.yksl, (this.ysbbForm.ykslDw - this.ycckdqkcslDwz) * 0.001) > this.ycckdqkcsl
        ) {
          flag = false
        }
      } else if (this.ysbbForm.ykslDw == this.ycckdqkcslDwz) {
        if (this.ysbbForm.yksl > this.ycckdqkcsl) {
          flag = false
        }
      }
      return flag
    },
    getCurrentDw() {
      switch (this.ysbbForm.ykslDw) {
        case '1': // 吨
          return this.ysbbForm.yksl * 1000000
        case '2': // 千克
          return this.ysbbForm.yksl * 1000
        case '3': // 克
          return this.ysbbForm.yksl
        case '4': // 升
          return this.ysbbForm.yksl * 1000
        case '5': // 毫升
          return this.ysbbForm.yksl
      }
    },
    getCountDw() {
      switch (this.ycckdqkcsl_dw) {
        case '吨':
          return this.ycckdqkcsl * 1000000
        case '千克':
          return this.ycckdqkcsl * 1000
        case '克':
          return this.ycckdqkcsl
        case '升':
          return this.ycckdqkcsl * 1000
        case '毫升':
          return this.ycckdqkcsl
      }
    },
    // 化学品下拉 同市运输
    hhuaxuepinchange(val) {
      this.ysbbForm.ycqCkid = ''
      this.ysbbForm.ycqCkmc= ''
      this.ysbbForm.ycckbgyId= ''
      this.ysbbForm.ycckbgyxm= ''
      this.ysbbForm.ycckbgydh= ''
      this.ysbbForm.ykslDw= ''
      this.ycckdqkcsl= ''
      this.ycckdqkcsl_dw= ''
      if (val) {
        this.ysbbForm.hxpBm = val[3]
        this.getYcckAndJbr(val[3])
        gethqdw(val[3]).then((res) => {
          this.ysbbForm.ykslDw = ''
          this.ckslList = res.data.data
        })
      }
    },
    // 运输许可证手动输入
    hyunshuXkz(val) {
      this.ysbbForm.ycqCkid = ''
      this.ysbbForm.ycqCkmc= ''
      this.ysbbForm.ycckbgyId= ''
      this.ysbbForm.ycckbgyxm= ''
      this.ysbbForm.ycckbgydh= ''
      this.ysbbForm.ykslDw= ''
      this.ycckdqkcsl= ''
      this.ycckdqkcsl_dw= ''
      if (val == '同市运输') {
        return
      }
      if (this.ysbbForm.yszBh !== '') {
        APIhqyszXq(this.ysbbForm.yszBh)
          .then((res) => {
            this.ysbbForm.hxpMc = res.data.data.hxpMc
            this.ysbbForm.hxpBm = res.data.data.hxpBm
            this.ysbbForm.yszs = res.data.data.yszBh
            this.ysbbForm.yszBh = res.data.data.yszBh
            this.ysbbForm.cydw = res.data.data.cydw
            this.ysbbForm.cydwTyshxydm = res.data.data.cydwTyshxydm

            // 移出仓库
            this.getYcckAndJbr(res.data.data.hxpBm)

            gethqdw(res.data.data.hxpBm).then((res) => {
              this.ckslList = res.data.data
            })
          })
          .catch((error) => {
            this.ysbbForm.hxpMc = ''
            this.ysbbForm.hxpBm = ''

            this.ysbbForm.yszs = ''
            this.ysbbForm.yszBh = ''
            this.ysbbForm.cydw = ''
            this.ysbbForm.cydwTyshxydm = ''
          })
      }
    },
    // 运输许可证  同市运输下拉
    hxsxkzchange(data) {
      if (data == '同市运输') {
        this.ysbbForm.yszBh = data
        this.ysbbForm.yszs = data
        this.ykbbycckXlList = []
        APIykbbhuoqumorenhxp().then((res) => {
          this.ykbbycckXlList = res.data.data
        })
      }
    },
    // 获取详情
    hhuoquxiangqing(id) {
      APIykbbxaingqing(id).then((res) => {
        let mesxx = {... res.data.data}
        if(this.childrenType != '查看'){
          mesxx.ycqCkid = this.ysbbForm.ycqCkid
          mesxx.ycqCkmc = this.ysbbForm.ycqCkmc
          mesxx.ychCkid = this.ysbbForm.ychCkid
          mesxx.ychCkmc = this.ysbbForm.ychCkmc
          mesxx.ycckbgyId = this.ysbbForm.ycckbgyId
          mesxx.ycckbgydh = this.ysbbForm.ycckbgydh
          mesxx.ycckbgyxm = this.ysbbForm.ycckbgyxm
          if(this.childrenType != '变更'){
            mesxx.yrckbgyId = this.ysbbForm.yrckbgyId
            mesxx.yrckbgydh = this.ysbbForm.yrckbgydh
            mesxx.yrckbgyxm = this.ysbbForm.yrckbgyxm
            mesxx.jbr = this.ysbbForm.jbr
            mesxx.jbrxm = this.ysbbForm.jbrxm
          }
        }
        this.ysbbForm = mesxx
        this.ysbbForm.cydwTyshxydm = res.data.data.cydwTyshxydm
        if (this.childrenType == '复制新增') this.ysbbForm.id = ''

        setTimeout(() => {
          if (this.ysbbForm.yszBh == '同市运输' && this.childrenType != '查看' && this.childrenType != '变更') {
            this.ysbbForm.hxpMc = res.data.data.hxpBm
          }
        }, 30)
        this.ysbbForm.hxpMc = res.data.data.hxpMc
        // this.hxpmc_cur = res.data.data.hxpMc;
        this.ysbbForm.yszBh = res.data.data.yszs

        // 移出仓库
        if(this.childrenType != '查看'){
          this.getYcckAndJbr(res.data.data.hxpBm,res.data.data)
          this.getYrckxxr(res.data.data)
        }else{
          this.ycckdqkcsl = res.data.data.ycckdqkcl
          this.ycckdqkcslDwz = res.data.data.ycckdqkclDw
          this.ycckdqkcsl_dw = res.data.data.ycckdqkclDwmc
        }
        if(res.data.data.hxpBm){
          gethqdw(res.data.data.hxpBm).then((res) => {
            this.ckslList = res.data.data
          })
        }
        this.$nextTick(() => {
          this.$refs.ysbbForm.clearValidate() //清楚页面所有校验结果
        })
        // this.$parent.checkedTableList = [];
      })
    },
    // 选择经办人
    hjbrChange(data) {
      this.jingbanrenlist.forEach((item) => {
        if (data == item.value) {
          this.ysbbForm.jbr = item.value
          this.ysbbForm.jbrxm = item.label
        }
      })
    },
    //移出仓库List
    getYcckAndJbr(hxpBm,dataMes){
      if(this.childrenType == '变更'){
        APIykbbycckXl(hxpBm,dataMes.ycqCkid).then((res) => {
          this.ykbbycckXlList = res.data.data
          this.hycckchange(dataMes.ycqCkid)
        })
      }else{
        if(hxpBm){
          APIykbbycckXl(hxpBm).then((res) => {
            this.ykbbycckXlList = res.data.data
            if (dataMes && dataMes.ycqCkid) {
              this.hycckchange(dataMes.ycqCkid)
            }
          })
        }
        if(dataMes){
          APIysbbjbrXl().then((res) => {
            this.jingbanrenlist = res.data.data
            this.hjbrChange(dataMes.jbr)
          })

        }
      }
    },
    //移入仓库List
    getYrckxxr(dataMes){
      if(this.childrenType == '变更'){
        APIykbbyrckXl(dataMes.ychCkid).then((res) => {
          this.ykbbyrckXlList = res.data.data
          this.ysbbForm.ychCkid = dataMes.ychCkid
          this.ysbbForm.ychCkmc = dataMes.ychCkmc
        })
      }else{
        APIykbbyrckXl().then((res) => {
          this.ykbbyrckXlList = res.data.data
          if (dataMes && dataMes.ychCkid) {
            this.ykbbyrckXlList.findIndex((item) => {
              if(item.value == dataMes.ychCkid){
                this.ysbbForm.ychCkid = dataMes.ychCkid
                this.ysbbForm.ychCkmc = dataMes.ychCkmc
                this.ysbbForm.yrckbgyId = dataMes.yrckbgyId
                this.ysbbForm.yrckbgydh = dataMes.yrckbgydh
                this.ysbbForm.yrckbgyxm = dataMes.yrckbgyxm
                return
              }
            })
          }
        })
      }
    },
    // 移入仓库下拉
    hyrckchange(data) {
      this.ykbbyrckXlList.forEach((item) => {
        if (item.value == data) {
          this.ysbbForm.yrckbgyxm = item.ckbgy
          this.ysbbForm.yrckbgyId = item.ckbgyId
          this.ysbbForm.yrckbgydh = item.ckbgyDh
          this.ysbbForm.ychCkid = item.value
          // this.ysbbForm.ychCkmc = item.label;
        }
      })
    },
    // 移出仓库下拉
    hycckchange(data) {
      this.ykbbycckXlList.forEach((item) => {
        if (item.value == data) {
          this.ysbbForm.ycckbgyxm = item.ckbgy
          this.ysbbForm.ycckbgyId = item.ckbgyId
          this.ysbbForm.ycckbgydh = item.ckbgyDh
          this.ysbbForm.ycqCkid = item.value
          this.ysbbForm.ycqCkmc = item.label
          this.ycckdqkcsl = item.kcl
          this.ycckdqkcslDwz = item.kclDw
          this.ycckdqkcsl_dw = item.kclDwLabel
        }
      })
    },
    // 获取运输报备弹框内容
    async htableData() {
      this.bgform.param.vdata = await dealDataGy()
      APIysbbtableData(this.bgform).then((res) => {
        this.tableData = res.data.data.rows
      })
    },

    back() {
      this.$parent.pupopShow = false
    },

    htjbg() {
      this.$refs.ysbbForm.validate((valid) => {
        if (valid) {
          const obj = {
            id: this.ysbbForm.id,
            hxpBm: this.ysbbForm.hxpBm,
            ycqCkid: this.ysbbForm.ycqCkid,
            ychCkid: this.ysbbForm.ychCkid,
            yksl: this.ysbbForm.yksl,
            ykslDw: this.ysbbForm.ykslDw
          }
          // 仓库id 是否一致
          if (this.yc_yr_ckID_validate()) {
            return
          }
          this.loading = true
          APIykbbbgjiaoyan(obj).then((res) => {
            this.loading = false
            const duixaing = {
              id: this.ysbbForm.id,
              hxpBm: this.ysbbForm.hxpBm,
              ycqCkid: this.ysbbForm.ycqCkid,
              ychCkid: this.ysbbForm.ychCkid,
              yksl: this.ysbbForm.yksl,
              ykslDw: this.ysbbForm.ykslDw,
              ykrq: this.ysbbForm.ykrq, // 移库日期 2022/1/19@y
              bgly: this.ysbbForm.bgly // 变更理由
            }
            if (res.data.data.type == 'success') {
              //
              this.$confirm('是否确认提交变更?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.loading = true
                APIykbbbgtijiao(duixaing).then((res) => {
                  this.loading = false
                  this.$parent.htableDataall()
                  this.$parent.pupopShow = false
                  this.$message({
                    type: 'success',
                    message: '提交成功!'
                  })
                }).catch((error) => {
                  this.loading = false
                })
              })
            } else {
              this.$confirm(
                "<span style='color:red'>" +
                  res.data.data.msg +
                  '</span>,是否确认提交变更?',
                '提示',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  dangerouslyUseHTMLString: true,
                  type: 'warning'
                }
              ).then(() => {
                this.loading = true
                APIykbbbgtijiao(duixaing).then((res) => {
                  this.loading = false
                  this.$parent.htableDataall()
                  this.$parent.pupopShow = false
                  this.$message({
                    type: 'success',
                    message: '提交成功!'
                  })
                }).catch((error) => {
                  this.loading = false
                })
              })
            }
          }).catch((error) => {
            this.loading = false
          })
        }
      })
    },

    // 确定
    hqueding() {
      this.$parent.pupopShow = false
    },
    // 暂时保存/编辑变更
    // 2022/1/13
    /*
      (朱老师提出的)要求:移出仓库和移入仓库不能是同一个 通过仓库id区分
      (衍生的问题=>俩仓库的id不一样 但是名称是一样的 也会提示,导致不能进行移库报备=>文静说如果存在此问题 是历史数据问题,一般不会出现此错误)
    */
    ZSsave() {
      this.ysbbForm.zt = '00'
      // 仓库id 是否一致
      if (this.cur_ycck_id && this.cur_yrck_id && this.yc_yr_ckID_validate()) {
        return
      }
      if (this.ysbbForm.id) {
        this.loading = true
        APIzancunbianjiTemp(this.ysbbForm).then((res) => {
          this.loading = false
          this.$parent.pupopShow = false
          this.$parent.reset()
        }).catch((error) => {
          this.loading = false
        })
      } else {
        APIysbbzanshibcTemp(this.ysbbForm).then((res) => {
          this.$parent.pupopShow = false
          this.$parent.reset()
        })
      }
    },

    // 报备
    hbaocun() {
      this.$refs.ysbbForm.validate((valid) => {
        if (valid) {
          this.ysbbForm.zt = '01'
          // 仓库id 是否一致
          if (this.yc_yr_ckID_validate()) {
            return
          }
          if (this.childrenType == '编辑') {
            // edit
            this.loading = true
            APIzancunbianji(this.ysbbForm).then((res) => {
              this.loading = false
              this.$parent.pupopShow = false
              this.$parent.reset()
            }).catch((error) => {
              this.loading = false
            })
          } else {
            // add
            APIysbbzanshibc(this.ysbbForm).then((res) => {
              this.$parent.pupopShow = false
              this.$parent.reset()
            })
          }
        }
      })
    },
    // 运输证弹窗
    dialogShow() {
      this.dialogVisible = true
    },

    // 确定运输证弹框
    hquedingTK() {
      if (this.andleSelectionChangeData_obj == {}) {
        this.$message.error('请选择')
        return
      }
      APIhqyszXq(this.andleSelectionChangeData_obj.xkzBh).then((res) => {
        this.ysbbForm.ycqCkid = ''
        this.ysbbForm.ycqCkmc= ''
        this.ysbbForm.ycckbgyId= ''
        this.ysbbForm.ycckbgyxm= ''
        this.ysbbForm.ycckbgydh= ''
        this.ysbbForm.ykslDw= ''
        this.ycckdqkcsl= ''
        this.ycckdqkcsl_dw= ''
        this.dialogVisible = !this.dialogVisible
        this.ysbbForm.hxpMc = res.data.data.hxpMc
        this.ysbbForm.hxpBm = res.data.data.hxpBm

        this.ysbbForm.yszs = res.data.data.yszBh
        this.ysbbForm.yszBh = res.data.data.yszBh
        this.ysbbForm.cydw = res.data.data.cydw
        this.ysbbForm.cydwTyshxydm = res.data.data.cydwTyshxydm
        // this.hxpmc_cur = res.data.data.hxpMc;
        //  console.log('---->', this.ysbbForm.yszBh != '同市运输', this.ckdisable , this.bgdisable)
        // 移出仓库
        this.getYcckAndJbr(res.data.data.hxpBm)

        gethqdw(res.data.data.hxpBm).then((res) => {
          this.ckslList = res.data.data
        })
        this.$refs.ysbbForm.clearValidate(['yszBh','cydw','cydwTyshxydm'])
      })
    },

    // 购买证运输证单选
    handleSelectionChange(val) {
      if (val.length !== 0) {
        this.andleSelectionChangeData_id = val[0].id
        this.andleSelectionChangeData_obj = val[0]
      }
      if (val.length > 1) {
        this.$refs.xsckTable.clearSelection()
        this.$refs.xsckTable.toggleRowSelection(val.pop())
      }
    },
    // 删除全选按钮
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disableheadselection'
      }
    },

    // 内部分页方法
    pagesizeChange(val) {
      this.bgform.size = val
    },
    handleCurrentChange(val) {
      this.bgform.page = val
    }
  }
}
</script>
<style scoped lang='less'>
.yk_report_pupop {
  padding-top: 10px;
  .yk_report_form {
    width: 90%;
    max-width: 1195px;
    background-color: white;
    margin: auto;

    .ykbb {
      width: 90%;
      margin: auto;
      padding-top: 40px;
      padding-bottom: 10px;
    }
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .el-form-item {
        margin-right: 0;
        width: 50%;
      }
    }
  }
  .xuanze {
    margin-left: 10px;
    color: #ffffff;
    width: 65px;
    height: 39px;
    background: #4170ff;
    border-radius: 2px;
  }
  .buttonList {
    width: 498px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 45px;
    display: flex;
    justify-content: center;
    .el-button:nth-child(1) {
      margin-right: 195px;
      background-color: #ebebeb;
      width: 148px;
      height: 60px;
      color: #333333;
      border: none;
    }
    .el-button:nth-child(2) {
      background-color: #4170ff;
      color: white;
      width: 148px;
      height: 60px;
      border: none;
    }
  }
}

.backButton {
  width: 148px;
  margin: 30px auto 10px auto;
  .el-button {
    margin: 30px auto;
    background-color: #4170ff;
    width: 148px;
    height: 60px;
    color: white;
    border: none;
  }
}

/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
</style>
